import { useContext, createContext } from 'react';

export const ExpressionsContext = createContext(null);

export function useExpressionsContext() {
  return useContext(ExpressionsContext);
}
